import {
  GetCulpritTimeSetQueryParamsType,
  GetCulpritTimeSetQueryResponseType,
} from '@/common/queries/getCulpritTimeSet/getCulpritTimeSetQuery.type';
import { fetchApi } from '@/config/axiosSetting';

export const getCulpritTimeSetFunction = (
  params: GetCulpritTimeSetQueryParamsType,
): Promise<GetCulpritTimeSetQueryResponseType> => {
  return fetchApi.get(`/actions/${params?.id}/time_set/`, { params });
};
